<template>
  <div class="tank-item">
    <HeadLine>
      {{ section['lang']['tank'] }} {{ data['name'] }}
    </HeadLine>
    <div class="th-fields-container details">
      <div class="column">
        <ValueField :label="$ml.get('Tank volume (' + $store.getters['unit/getLabel']('L')) + ')'" :value="parseFloat($store.getters['unit/convert']('L', data['volume'])).toFixed(1) + ' ' + $ml.get($store.getters['unit/getLabel']('L'))"/>
        <ValueField :label="section['lang']['water']" :value="parseFloat($store.getters['unit/convert']('L', data['tank']['Water'])).toFixed(1) + ' ' + $ml.get($store.getters['unit/getLabel']('L'))"/>
      </div>
      <div class="column">
        <template v-if="data['injection_ratio']">
          <ValueField 
            :label="$ml.get('Injection ratio')" 
            :value="parseFloat($store.getters['unit/convert']('L/m3', data['injection_ratio'])).toFixed(2) + ' ' + $ml.get($store.getters['unit/getLabel']('L/m3'))"
          />
        </template>
        <template v-else>
          <ValueField :label="section['lang']['app']" :value="data['applications']"/>
        </template>

        <ValueField :label="section['lang']['liq']" :value="data['tank']['LiquidFerts'].toFixed(2) + ' ' + $ml.get($store.getters['unit/getLabel']('L'))"/>
      </div>
    </div>

    <table class="th-table">
      <tr class="head">
        <td>
          {{ section['lang']['fert'] }}
        </td>
        <td>
          {{ section['lang']['amount'] }}
        </td>
      </tr>

      <tr v-for="fert in data['tank']['Fertilizers']['Fertilizer']">
        <td>
          {{ fert['Name'] }}
        </td>

        <td v-if="fert['VolumeMass']">
          {{ parseFloat($store.getters['unit/convert'](fert['Unit'], fert['VolumeMass'])).toFixed(2) }} {{ $ml.get($store.getters['unit/getLabel'](fert['Unit'])) }}
        </td>
        <td v-else>
          {{ parseFloat($store.getters['unit/convert'](fert['Unit'], fert['Conc'])).toFixed(2) }} {{ $ml.get($store.getters['unit/getLabel'](fert['Unit'])) }}
        </td>
      </tr>

    </table>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
import ValueField from './../../components/common/ValueField';
export default {
  props: {
    data: {},
  },

  components: {
    HeadLine,
    ValueField,
  },

  computed: {
    section() {
      return this.$root.data.fertigation;
    }
  },
}
</script>

<style lang="scss" scoped>

.tank-item {

  .details {
    margin-bottom: 20px;
  }

  .head-line {
    background: #E5E5E5;
    color: #2c3e50;
  }
}

</style>